import homePageImagePaths from '@/constants/ImagePaths/Homepage/homePageImagePaths';

const businessAdvantagesData = {
  title: 'Razorswift Advantage for Businesses',
  button: { title: 'Know More', link: '/business#advantages-section' },
  image: homePageImagePaths.businessCard,
};

export default businessAdvantagesData;
